import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Button } from 'antd';
import Icon from 'kts-platform-frame/display/components/Icon';
import { create } from 'kts-scaffold-framework/utils/form';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: IUserInfo;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo,
}))
export default class UIInfo extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <div className={css.ModalChangePhoneNum}>
                <div className={css.header}>
                    <div className={css.title}>密码验证</div>
                    <div className={css.titleDes}>请确认您的登录密码再进行下一步操作</div>
                </div>
                <div className={css.content}>
                    <div>
                        <Form className={`${css.changePhoneForm} clear`}>
                            <Form.Item className={css.noBoder}>
                                {getFieldDecorator('username', {
                                    rules: [{ required: false, message: '手机号不能为空' }],
                                    initialValue: this.modulesState.changePhoneNum || undefined
                                })(
                                    <Input
                                        placeholder="手机号"
                                        disabled={true}
                                        prefix={<Icon className={css.inputIcon} color="#000" width={14} height={14} src={require('./img/img.phone.svg')} />}
                                    />
                                )}
                            </Form.Item>

                            <Form.Item>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: '密码不能为空' }],
                                })(
                                    <Input
                                        type="password"
                                        placeholder="密码"
                                        prefix={<Icon className={css.inputIcon} color="#000" width={14} height={14} src={require('./img/img.password.svg')} />}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                    <div className={css.footerBt}>
                        <Button onClick={this.nextStep} className={css.nextBt}>下一步</Button>
                        <Button onClick={ModulesAction.closeChangePhoneM} className={css.cancelBt}>取消</Button>
                    </div>
                                
                </div>
            </div>
        );
    }
    /** 下一步 */
    private nextStep = () => {
        this.props.form.validateFields((err, val) => {
            if (!err) {
                ModulesAction.verificationPassword(val);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.VerificationPassword.tsx